import { Injectable } from '@angular/core';
import { BrandResources } from '@domain/models/brand/brand-resources.model';
import { BrandGateway } from '@domain/models/brand/gateway/brand.gateway';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BrandResourcesUseCase {
  constructor(private _brandGateway: BrandGateway) {}

  getBrandResources(brand: string): Observable<BrandResources> {
    return this._brandGateway.getBrandResources(brand);
  }

  getSelectedBrandResources(): Observable<BrandResources> {
    return this._brandGateway.getSelectedBrandResources();
  }

  getBrandTitle(): Observable<string | null> {
    return this._brandGateway.getBrandTitle();
  }
}
